var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.acao
    ? _c("div", [
        _vm._v(" " + _vm._s(_vm.campos) + " "),
        _vm.dados.campo_parametro
          ? _c("p", { staticStyle: { "font-weight": "bold" } }, [
              _vm._v(" " + _vm._s(_vm.acao) + " ")
            ])
          : _vm._e(),
        _vm.acao === "low_return"
          ? _c(
              "div",
              {
                staticClass: "d-flex align-baseline",
                staticStyle: { "flex-wrap": "wrap" }
              },
              [
                _c("p", { staticStyle: { "max-width": "230px" } }, [
                  _vm._v("Analisar clientes que possuem a")
                ]),
                _c("v-select", {
                  staticClass: "ml-2",
                  staticStyle: { "max-width": "240px" },
                  attrs: {
                    dense: "",
                    "hide-details": "",
                    value: _vm.dados.campo_parametro,
                    items: _vm.campos.campo_parametro,
                    label: "Rentabilidade",
                    width: "150"
                  }
                }),
                _c("v-select", {
                  staticClass: "ml-2",
                  staticStyle: { "max-width": "100px" },
                  attrs: {
                    dense: "",
                    "hide-details": "",
                    value: _vm.dados.tipo_comparacao_parametro,
                    items: _vm.campos.tipo_comparacao_parametro,
                    label: "Comparação"
                  }
                }),
                _c("p", { staticStyle: { "max-width": "fit-content" } }, [
                  _vm._v("que")
                ]),
                _c("v-text-field", {
                  staticClass: "ml-2",
                  staticStyle: { "max-width": "140px" },
                  attrs: {
                    dense: "",
                    "hide-details": "",
                    value: _vm.dados.valor_parametro,
                    label: "Porcentagem"
                  }
                }),
                _c("Valor", { attrs: { type: _vm.dados.tipo_dado_parametro } })
              ],
              1
            )
          : _vm._e(),
        _vm.acao === "low_share"
          ? _c(
              "div",
              {
                staticClass: "d-flex align-baseline",
                staticStyle: { "flex-wrap": "wrap" }
              },
              [
                _c("p", { staticStyle: { "max-width": "400px" } }, [
                  _vm._v(
                    " Analisar clientes que possuem patrimônio representando "
                  )
                ]),
                _c("v-select", {
                  staticClass: "ml-2",
                  staticStyle: { "max-width": "110px" },
                  attrs: {
                    dense: "",
                    "hide-details": "",
                    value: _vm.dados.tipo_comparacao_parametro,
                    items: _vm.campos.tipo_comparacao_parametro,
                    label: "Comparação"
                  }
                }),
                _c("p", { staticStyle: { "max-width": "fit-content" } }, [
                  _vm._v("que")
                ]),
                _c("v-text-field", {
                  directives: [
                    {
                      name: "money",
                      rawName: "v-money",
                      value: _vm.maskPercent,
                      expression: "maskPercent"
                    }
                  ],
                  staticClass: "ml-2",
                  staticStyle: { "max-width": "100px" },
                  attrs: {
                    dense: "",
                    "hide-details": "",
                    value: _vm.dados.valor_parametro,
                    label: "Valor parametro"
                  }
                }),
                _c("p", { staticStyle: { "max-width": "fit-content" } }, [
                  _vm._v("na instituição")
                ]),
                _c("v-select", {
                  staticClass: "ml-2",
                  staticStyle: { "max-width": "230px" },
                  attrs: {
                    dense: "",
                    label: "Instituição",
                    multiple: "",
                    value: _vm.dados.valor_parametro_v2,
                    items: _vm.campos.valor_parametro_v2
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _vm.acao === "not_contracted"
          ? _c(
              "div",
              {
                staticClass: "d-flex align-baseline",
                staticStyle: { "flex-wrap": "wrap" }
              },
              [
                _c("p", { staticStyle: { "max-width": "fit-content" } }, [
                  _vm._v(" Analisar clientes que receberam proposta a ")
                ]),
                _c("v-select", {
                  staticClass: "ml-2",
                  staticStyle: { "max-width": "fit-content" },
                  attrs: {
                    dense: "",
                    "hide-details": "",
                    value: _vm.dados.tipo_comparacao_parametro,
                    items: _vm.campos.tipo_comparacao_parametro,
                    label: "Comparação"
                  }
                }),
                _c("v-text-field", {
                  staticClass: "ml-2",
                  staticStyle: { "max-width": "fit-content" },
                  attrs: {
                    dense: "",
                    "hide-details": "",
                    value: _vm.dados.tipo_comparacao_parametro,
                    label: "Valor parametro"
                  }
                }),
                _c("p", { staticStyle: { "max-width": "fit-content" } }, [
                  _vm._v("dias")
                ])
              ],
              1
            )
          : _vm._e(),
        _vm.acao === "not_registered"
          ? _c(
              "div",
              {
                staticClass: "d-flex align-baseline",
                staticStyle: { "flex-wrap": "wrap" }
              },
              [
                _c("p", { staticStyle: { "max-width": "fit-content" } }, [
                  _vm._v(
                    " Analisar clientes cadastrados que ainda não acessaram o app em "
                  )
                ]),
                _c("v-select", {
                  staticClass: "ml-2",
                  staticStyle: { "max-width": "fit-content" },
                  attrs: {
                    dense: "",
                    "hide-details": "",
                    value: _vm.dados.tipo_comparacao_parametro,
                    items: _vm.campos.tipo_comparacao_parametro,
                    label: "Comparação"
                  }
                }),
                _c("v-text-field", {
                  staticClass: "ml-2",
                  staticStyle: { "max-width": "fit-content" },
                  attrs: {
                    dense: "",
                    "hide-details": "",
                    value: _vm.dados.tipo_comparacao_parametro,
                    label: "Valor parametro"
                  }
                }),
                _c("p", { staticStyle: { "max-width": "fit-content" } }, [
                  _vm._v("dias")
                ])
              ],
              1
            )
          : _vm._e(),
        _vm.acao === "wihout_profit"
          ? _c(
              "div",
              {
                staticClass: "d-flex align-baseline",
                staticStyle: { "flex-wrap": "wrap" }
              },
              [
                _c("p", { staticStyle: { "max-width": "fit-content" } }, [
                  _vm._v("Analisar clientes que não geraram receita e que")
                ]),
                _c("v-select", {
                  staticClass: "ml-2",
                  staticStyle: { "max-width": "150px" },
                  attrs: {
                    dense: "",
                    "hide-details": "",
                    value: _vm.dados.campo_parametro,
                    items: _vm.campos.campo_parametro,
                    label: "Data"
                  }
                }),
                _c("p", [_vm._v("em")]),
                _c("v-select", {
                  staticClass: "ml-2",
                  staticStyle: { "max-width": "fit-content" },
                  attrs: {
                    dense: "",
                    "hide-details": "",
                    value: _vm.dados.tipo_comparacao_parametro,
                    items: _vm.campos.tipo_comparacao_parametro,
                    label: "Comparação"
                  }
                }),
                _c("v-text-field", {
                  staticClass: "ml-2",
                  staticStyle: { "max-width": "fit-content" },
                  attrs: {
                    dense: "",
                    "hide-details": "",
                    value: _vm.dados.valor_parametro,
                    label: "Valor parametro"
                  }
                }),
                _c("p", { staticStyle: { "max-width": "fit-content" } }, [
                  _vm._v("dias")
                ])
              ],
              1
            )
          : _vm._e(),
        _vm.acao === "without_invite"
          ? _c(
              "div",
              {
                staticClass: "d-flex align-baseline",
                staticStyle: { "flex-wrap": "wrap" }
              },
              [
                _c("p", { staticStyle: { "max-width": "fit-content" } }, [
                  _vm._v(
                    " Analisar clientes que não receberam convites mas se registraram em "
                  )
                ]),
                _c("v-select", {
                  staticClass: "ml-2",
                  staticStyle: { "max-width": "fit-content" },
                  attrs: {
                    "hide-details": "",
                    dense: "",
                    value: _vm.dados.tipo_comparacao_parametro,
                    items: _vm.campos.tipo_comparacao_parametro,
                    label: "Comparação"
                  }
                }),
                _c("v-text-field", {
                  staticClass: "ml-2",
                  staticStyle: { "max-width": "fit-content" },
                  attrs: {
                    "hide-details": "",
                    dense: "",
                    value: _vm.dados.tipo_comparacao_parametro,
                    label: "Valor parametro"
                  }
                }),
                _c("p", { staticStyle: { "max-width": "fit-content" } }, [
                  _vm._v("dias")
                ])
              ],
              1
            )
          : _vm._e(),
        _vm.acao === "without_position"
          ? _c(
              "div",
              {
                staticClass: "d-flex align-baseline",
                staticStyle: { "flex-wrap": "wrap" }
              },
              [
                _c("p", { staticStyle: { "max-width": "fit-content" } }, [
                  _vm._v(
                    " Analisar clientes que não possuem ativos mas se registraram em "
                  )
                ]),
                _c("v-select", {
                  staticClass: "ml-2",
                  staticStyle: { "max-width": "fit-content" },
                  attrs: {
                    dense: "",
                    "hide-details": "",
                    value: _vm.dados.tipo_comparacao_parametro,
                    items: _vm.campos.tipo_comparacao_parametro,
                    label: "Comparação"
                  }
                }),
                _c("v-text-field", {
                  staticClass: "ml-2",
                  staticStyle: { "max-width": "fit-content" },
                  attrs: {
                    dense: "",
                    "hide-details": "",
                    value: _vm.dados.tipo_comparacao_parametro,
                    label: "Valor parametro"
                  }
                }),
                _c("p", { staticStyle: { "max-width": "fit-content" } }, [
                  _vm._v("dias")
                ])
              ],
              1
            )
          : _vm._e(),
        _vm.dados.frequencia
          ? _c("div", [
              _c("p", { staticStyle: { "max-width": "fit-content" } }, [
                _vm._v(
                  " Executada a cada " +
                    _vm._s(_vm.dados.frequencia) +
                    " " +
                    _vm._s(_vm.dados.escala_frequencia) +
                    " "
                )
              ])
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }